var _circle, _circle2, _linearGradient, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextjsDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 90,
    fill: "#e0e0e0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 90,
    fill: "#e0e0e0"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 93.23,
    x2: 128.73,
    y1: 52.776,
    y2: 8.776,
    fill: "#e0e0e0",
    gradientTransform: "matrix(1 0 0 -1 0 182)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 157.5 69.1 54H54v72h12.1V69.4l73.9 95.5c3.3-2.3 6.5-4.7 9.5-7.4",
    style: {
      fill: "url(#a)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115 54h12v72h-12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextjsDarkMode);
export default __webpack_public_path__ + "static/media/nextjs-dark-mode.0c5656acd771bfa67e36bf363df144b3.svg";
export { ForwardRef as ReactComponent };